import { useState, useEffect } from "react";
import Timer from "./stopwatch/Timer";
import { clearInterval, clearTimeout, setInterval, setTimeout } from 'worker-timers';

/** * StopWatch component that displays a timer based on the initial time and start date.
 * It updates every second when isActive is true.
 * @param {Object} props - The properties passed to the component.
 * @param {number} props.initialTime - The initial time in milliseconds.
 * @param {string} props.initialStartDate - The initial start date in ISO format.
 * @param {boolean} props.isActive - A flag indicating whether the stopwatch is active.
 * @param {string} props.viewMode - The view mode of the stopwatch (e.g., 'LIST', 'KANBAN', 'CALENDAR').
 * @returns {JSX.Element} The rendered StopWatch component.
 */
function StopWatch(props) {
  	const { 
		initialTime, 
		initialStartDate, 
		isActive, 
		viewMode, 
		className
	}  = props;
  	let date_now = new Date();
  	let date_from = new Date(initialStartDate);
  	let seconds = (date_now.getTime() - date_from.getTime());
  	let startTime = false ? (initialTime + seconds) : initialTime
  	const [time, setTime] = useState(startTime || 0);
  	const [startDate, setStartDate] = useState(initialStartDate);

	useEffect(() => {
		let interval = null;

		if (isActive) {
			interval = setInterval(() => {
				setTime((time) => time + 1000);
			}, 1000);
		} else {
			if (interval) clearInterval(interval);
		}
		return () => {
			if (interval) clearInterval(interval);
		};
	}, [isActive]);

	useEffect(() => {
		if (startDate !== initialStartDate ){
			setStartDate(initialStartDate)
			setTime(initialTime)
		}
	}, [initialTime]);

	useEffect(() => {
		if (initialTime !== time ){
			setTime(initialTime)
		}
	}, [isActive, initialTime]);

	const getClassName = () => {
		switch (viewMode) {
			case 'LIST':
				return 'stop-watch--list mt-2';
			case 'KANBAN':
				return 'stop-watch--kanban mb-1';
			case 'CALENDAR':
				return 'stop-watch--calendar';
			case 'POPUP':
				return `stop-watch--popup ${isActive ? 'is-active' : ''}`;
			default:
				return '';
		}
	};

	return (
		<div className={`stop-watch ${getClassName()} ${className}`}>
			<Timer time={time} />
		</div>
	);
}

export { StopWatch };
